<div class="login-card">
  <h2>Anmelden</h2>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <label>
      Benutzername
      <input formControlName="username" autocomplete="username" />
    </label>

    <label>
      Passwort
      <input type="password" formControlName="password" autocomplete="current-password" />
    </label>

    <label class="remember">
      <input type="checkbox" formControlName="remember" /> Anmeldung merken
    </label>

    <div *ngIf="error" class="error">{{ error }}</div>

    <button type="submit" [disabled]="loading">{{ loading ? 'Bitte warten...' : 'Anmelden' }}</button>
  </form>
</div>
